module.exports = __webpack_public_path__ + "img/logo-company.722dc81c.svg";